import styled from 'styled-components';

const MyInfoText = styled.div`
    font-size: 0.875rem;
`;

export default MyInfoText;